<template>
  <div>
    <table class="w-100">
      <tr>
        <td class="bolder ">
          <mdb-input class="mb-1" v-model="lecture.name" label="단원명" icon="chalkboard" disabled/>
        </td>
        <td style="width:50px">
          <mdb-input class="mb-1 mr-0" label="시수" type="number" v-model="lecture.hours" style="width:50px"/>
        </td>
      </tr>
    </table>
    <div class="ml-5">
      <table class="w-100">
        <tr>
          <td class="pr-4">
            <label class="bolder">
              <input type="checkbox" v-model="lecture.portfolio">
              포트폴리오 여부
            </label>
          </td>
        </tr>        <tr>
          <td colspan="3">
            <mdb-badge class="p-1 mr-3" style="font-size:14px">평가 비율 </mdb-badge>
            필답 평가: <input type="number" v-model="lecture.evalRatio.writing" class="underline" style="width:50px"/>
            수행 평가: <input type="number" v-model="lecture.evalRatio.perform" class="underline" style="width:50px"/>
            태도 평가: <input type="number" v-model="lecture.evalRatio.attitude" class="underline" style="width:50px"/>
            포트폴리오: <input type="number" v-model="lecture.evalRatio.portfolio" class="underline" style="width:50px"/>
          </td>
        </tr>
        <tr>
          <td class=""><date-picker2 v-model="lecture.testDate" label="진단평가"/></td>
          <td class=""><date-picker2 v-model="lecture.startDate" label="시작일"/></td>
          <td class=""><date-picker2 v-model="lecture.endDate" label="종료일"/></td>
        </tr>      </table>
      <table class="w-100">
        <tr class="grey lighten-3">
          <th  class="bolder">능력단위명</th>
          <th class="bolder ">능력단위코드</th>
          <th class="bolder " style="width:50px">시수</th>
        </tr>
        <tr v-for="(u , ui) in lecture.units" :key="ui">
          <td class="">
            <input class="input-underline my-2 w-100 white" v-model="u.name" disabled/>
          </td>
          <td>
            <input class="input-underline my-2 w-100 white" v-model="u.code" disabled/>
          </td>
          <td class="">
            <input class="input-underline" type="number" v-model="u.hours" style="width:50px"/>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';
export default {
  name: 'NcsLectureEdit',
  components: { },
  props: ['lecture'],
  data: () => ({
  }),
  created () {
    if (this.lecture) {
      if (!this.lecture.evalRatio) {
        this.lecture.evalRatio = {
          writing: 0, perform: 0, attitude: 0, portfolio: 0
        }
      }
    }
  }
}
</script>
